<template>
  <v-container fluid class="py-6">
    <v-row>
      <v-col md="12" lg="12" cols="12">
          <v-card class="border-radius-xl overflow-hidden card-shadow h-100">
            <div
                class="
              px-4
              py-4
              d-flex
              flex-column
              justify-center
              text-center
              h-100
            "
            >
              <h5 class="text-h5 text-secondary font-weight-bold mb-2">
                Upload Bulk Returns
              </h5>
              <v-row>
                <v-col
                    cols="1"
                    md="1"
                    class="align-content-center"
                >

                </v-col>
                <v-col
                    cols="2"
                    md="2"
                    class="align-content-center"
                >
                  <v-select
                      :items="[{ text: 'USD', value: 'USD'}, { text: 'ZWG', value: 'ZWG'}]"
                      v-model="currency"
                      item-value="value"
                      item-text="text"
                      label="Select currency"
                      color="rgba(0,0,0,.6)"
                      class="
                      input-style
                      font-size-input
                      text-light-input
                      placeholder-light
                      border-radius-md
                      select-style
                      mt-2
                      mb-0
                    "
                      outlined
                      single-line
                      height="55"
                  >
                  </v-select>
                </v-col>
                <v-col
                    cols="4"
                    md="4"
                    class="align-content-center"
                >
                  <v-select
                      :items="periods"
                      v-model="period"
                      item-value="value"
                      item-text="text"
                      label="Select period"
                      color="rgba(0,0,0,.6)"
                      class="
                      input-style
                      font-size-input
                      text-light-input
                      placeholder-light
                      border-radius-md
                      select-style
                      mt-2
                      mb-0
                    "
                      outlined
                      single-line
                      height="55"
                  >
                  </v-select>
                </v-col>
                <v-col
                    cols="4"
                    md="4"
                    class="align-content-center"
                >
                  <input class="mt-3" type="file" ref="myFile" @change="PreviewFile" hidden>
                  <v-file-input
                      :disabled="period === ''"
                      @change="getGrades()"
                      v-model="files"
                      accept=".xls , .xlsx"
                      label="Click here to upload returns"
                      multiple
                      outlined
                      class="
                           input-style
                      font-size-input
                      text-light-input
                      placeholder-light
                      border-radius-md
                      select-style
                      mt-2
                      mb-0
                        "
                      single-line
                      height="55"
                  >
                    <template v-slot:selection="{ text }">
                      <v-chip
                          small
                          label
                          color="secondary"
                          style="color: #1a252f"
                      >
                        {{ text }}
                      </v-chip>
                    </template>
                  </v-file-input>
                </v-col>
                <v-col
                    cols="1"
                    md="1"
                ></v-col>
              </v-row>
              <div class="w-100 justify-center mt-4">
                <v-btn
                    :disabled="files.length < 1"
                    color="#cb0c9f"
                    class="
                          font-weight-bolder
                          btn-default
                          bg-gradient-default
                          py-5
                          px-4
                        "
                    small
                    @click="AddReturns()"
                >
                  Upload File
                </v-btn>
              </div>
                <hr class="horizontal dark mt-4 mb-4" />
                <a
                    href="#"
                    class="
                      text-decoration-none
                      btn-hover
                      text-primary text-body-2
                      ls-0
                    "
                    @click="DownloadSample()"
                >Download CSV Template</a>
            </div>
          </v-card>
      </v-col>
      <v-col lg="6" cols="12" v-if="false">
        <v-card class="card-shadow border-radius-xl h-100">
          <div class="px-4 pt-4">
            <h6 class="mb-0 text-h6 text-typo font-weight-bold">Return Record</h6>
          </div>
          <div class="px-4 pt-4">
            <v-row class="mt-2">
              <v-col sm="12" cols="12">
                <label class="text-xs text-typo font-weight-bolder ms-1"
                >Fullname</label
                >
                <v-text-field
                    hide-details
                    outlined
                    color="rgba(0,0,0,.6)"
                    light
                    placeholder="eg. Michael Doe"
                    class="
                          font-size-input
                          placeholder-lighter
                          text-light-input
                          border border-radius-md
                          mt-2
                        "
                >
                </v-text-field>
              </v-col>
            </v-row>

            <v-row class="mt-2">
              <v-col sm="6" cols="12">
                <label class="text-xs text-typo font-weight-bolder ms-1"
                >ID Number</label
                >
                <v-text-field
                    hide-details
                    outlined
                    color="rgba(0,0,0,.6)"
                    light
                    placeholder="eg. 00-00123434Z00"
                    class="
                          font-size-input
                          placeholder-lighter
                          text-light-input
                          border border-radius-md
                          mt-2
                        "
                >
                </v-text-field>
              </v-col>
              <v-col sm="6" cols="12">
                <label class="text-xs text-typo font-weight-bolder ms-1"
                >Weeks Worked</label
                >
                <v-text-field
                    hide-details
                    outlined
                    type="number"
                    color="rgba(0,0,0,.6)"
                    light
                    placeholder="eg. 1"
                    class="
                          font-size-input
                          placeholder-lighter
                          text-light-input
                          border border-radius-md
                          mt-2
                        "
                >
                </v-text-field>
              </v-col>
            </v-row>

            <v-row class="mt-2">
              <v-col sm="6" cols="12">
                <label class="text-xs text-typo font-weight-bolder ms-1"
                >Class Grade</label
                >
                <v-select
                    label="Select grade"
                    :items="['Grade 1', 'Grade 2', 'Grade 3', 'Grade 4']"
                    v-model="grade"
                ></v-select>
              </v-col>
              <v-col sm="6" cols="12">
                <label class="text-xs text-typo font-weight-bolder ms-1"
                >General Fund</label
                >
                <v-text-field
                    hide-details
                    disabled
                    outlined
                    v-model="general_fund"
                    color="rgba(0,0,0,.6)"
                    light
                    placeholder="100.00"
                    class="
                          font-size-input
                          placeholder-lighter
                          text-light-input
                          border border-radius-md
                          mt-2
                        "
                >
                </v-text-field>
              </v-col>
            </v-row>
          </div>
          <div class="px-4 pb-4 d-flex align-center mt-8">
            <div class="w-60">
              <p class="text-sm text-body">
                Add your returns to the list below , then press <b>SUBMIT</b> once you have verified if the information
                is correct.
              </p>
            </div>
            <div class="w-40 text-end">
              <v-btn
                color="#cb0c9f"
                class="
                  font-weight-bolder
                  btn-default
                  bg-gradient-default
                  py-5
                  px-4
                "
                small
              >
                Add To List
              </v-btn>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <template>
          <div>
            <v-card class="card-shadow border-radius-xl mt-6">
              <v-card-title>Preview</v-card-title>
              <v-card-text class="px-0 py-0">
                <v-data-table
                    :headers="headers"
                    :items="returns"
                    :search="search"
                    class="table"
                    :page.sync="page"
                    hide-default-footer
                    @page-count="pageCount = $event"
                    :items-per-page="itemsPerPage"
                    mobile-breakpoint="0"
                >
                  <template v-slot:top>
                    <v-toolbar flat height="80">
                      <v-row>
                        <v-col cols="12" md="5">
                          <v-text-field
                              hide-details
                              class="
                      input-style
                      font-size-input
                      text-light-input
                      placeholder-light
                      input-icon
                    "
                              dense
                              flat
                              filled
                              solo
                              height="43"
                              v-model="search"
                              placeholder="Search"
                          >
                            <template slot="prepend-inner">
                              <v-icon color="#adb5bd" size=".875rem"
                              >fas fa-search</v-icon
                              >
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </v-toolbar>
                  </template>

                  <template v-slot:item.id="{ item }">
                    <div class="d-flex align-center">
                      <v-checkbox
                          :ripple="false"
                          v-model="item.checkbox"
                          color="#141727"
                      ></v-checkbox>
                      <span class="my-2 text-xs text-body font-weight-bold">{{
                          item.id
                        }}</span>
                    </div>
                  </template>

                  <template v-slot:item.date="{ item }">
            <span class="my-2 text-xs text-body font-weight-bold">{{
                item.date
              }}</span>
                  </template>

                  <template v-slot:item.status="{ item }">
                    <div class="d-flex align-center">
                      <v-btn
                          :ripple="false"
                          icon
                          outlined
                          rounded
                          width="25px"
                          height="25px"
                          class="me-2"
                          :class="
                  item.statusIcon == 'fas fa-check'
                    ? 'border-success'
                    : 'border-warning'
                "
                      >
                        <v-icon
                            size="8"
                            :class="
                    item.statusIcon == 'fas fa-check'
                      ? 'text-success'
                      : 'text-warning'
                  "
                        >
                          {{ item.statusIcon }}
                        </v-icon>
                      </v-btn>
                      <span class="text-body text-xs">{{ item.status }}</span>
                    </div>
                  </template>

                  <template v-slot:item.customer="{ item }">
                    <div class="d-flex align-center">
                      <v-avatar size="24" class="me-2" v-if="item.customerImg">
                        <v-img :src="item.customerImg"></v-img>
                      </v-avatar>

                      <v-avatar size="24" class="me-2 bg-gradient-default" v-else>
                        <span class="text-white text-xs">{{ item.customer[0] }}</span>
                      </v-avatar>
                      <span class="text-body text-xs font-weight-bold">{{
                          item.customer
                        }}</span>
                    </div>
                  </template>

                  <template v-slot:item.product="{ item }">
            <span class="my-2 text-xs text-body font-weight-bold">{{
                item.product
              }}</span>
                  </template>

                  <template v-slot:item.revenue="{ item }">
            <span class="my-2 text-xs text-body font-weight-bold">{{
                item.revenue
              }}</span>
                  </template>

                  <template v-slot:item.action="{ item }">
                    <v-btn
                        @click="goTo()"
                        elevation="0"
                        small
                        :ripple="false"
                        height="21"
                        class="
                    border-radius-sm
                    font-weight-bolder
                    px-2
                    py-2
                    badge-font-size
                    ms-auto
                    text-white text-xxs
                    mb-2
                  "
                        :class="
                    item.statusIcon == 'fas fa-check'
                      ? 'bg-gradient-success'
                      : 'bg-gradient-warning'
                  "
                    >{{item.statusIcon == 'fas fa-check'
                        ? 'View'
                        : 'View'}}</v-btn
                    >
                  </template>

                  <template v-slot:item.invoice="{ item }">
                    <v-btn
                        color="#fff"
                        class="text-dark font-weight-bolder px-1 shadow-0"
                        small
                        simple
                    >
                      <v-icon size="18" class="rotate-180"
                      >fas fa-file-pdf text-lg me-1</v-icon
                      >
                      Pdf
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
              <v-card-actions class="card-padding">
                <v-row>
                  <v-col cols="6" lg="3" class="d-flex align-center">
                    <span class="text-body me-3 text-sm">Items per page:</span>
                    <v-text-field
                        hide-details
                        type="number"
                        outlined
                        min="-1"
                        max="15"
                        background-color="rgba(255,255,255,.9)"
                        color="rgba(0,0,0,.6)"
                        light
                        :value="itemsPerPage"
                        @input="itemsPerPage = parseInt($event, 10)"
                        placeholder="Items per page"
                        class="
                font-size-input
                placeholder-lighter
                text-color-light
                input-alternative input-focused-alternative input-icon
              "
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="6" class="ml-auto d-flex justify-end">
                    <v-pagination
                        prev-icon="fa fa-angle-left"
                        next-icon="fa fa-angle-right"
                        class="pagination"
                        color="#cb0c9f"
                        v-model="page"
                        :length="pageCount"
                        circle
                    ></v-pagination>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </div>
        </template>
      </v-col>
    </v-row>
    <v-dialog
        v-model="successDialog"
        max-width="290"
        persistent
    >
      <v-card class="text-center ">
        <v-card-title class="text-h5 justify-center">
          Success
        </v-card-title>

        <v-card-text>
          Your upload has been done
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn
              color="green darken-1"
              text
              outlined
              @click="goTo()"
          >
            Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="errorDialog"
        max-width="290"
        persistent
    >
      <v-card class="text-center ">
        <v-card-title class="text-h5 justify-center">
          Error
        </v-card-title>

        <v-card-text>
          {{ errorMessage }}
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn
              color="danger darken-1"
              text
              outlined
              @click="errorDialog = false"
          >
            Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center">
      <v-overlay :value="overlay">
        <v-progress-circular
            indeterminate
            size="64"
        />
      </v-overlay>
    </div>
  </v-container>
</template>
<script>
import ReportsTable from "./Widgets/ReportsTable.vue";
import Dropzone from "@/views/Client/Products/Widgets/Dropzone";
import * as XLSX from "xlsx/xlsx";
import axios from "axios";
import {mapState} from "vuex";
import moment from 'moment'

export default {
  name: "Dashboard",
  data() {
    return {
      currency: "USD",
      overlay: false,
      fileSingle: [],
      page: 1,
      successDialog: false,
      errorDialog: false,
      files:[],
      pageCount: 0,
      itemsPerPage: 10,
      search: "",
      month:"",
      period:"",
      errorMessage: "There was an error adding your returns",
      year: "",
      general_fund: 0.0,
      grade:"",
      grades: [],
      periods: [],
      returns: [],
      headers: [
        {
          text: "Fullname",
          value: "Fullname",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "ID Number",
          value: "IDNumber",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Weeks",
          value: "WeeksWorked",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Rate",
          value: "rate",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Grade",
          value: "Grade",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "General Fund",
          value: "general_fund",
          class: "text-secondary font-weight-bolder opacity-7",
        },

      ],
    };
  },
  components: {
    ReportsTable,
    Dropzone,
  },
  computed: {
    ...mapState(['base_url', 'OrgId', 'isAuthenticated']),
  },
  created () {
    if (!this.isAuthenticated && this.is_admin) {
      this.$router.push("/login");
    }
    else{
      this.getPeriods()
    }
  },
  methods: {
    goTo(){
      this.$router.push("/client-returns");
    },
    async PreviewFile(){
      this.overlay = true
      if (this.files.length === 0) {
        this.overlay = false
        this.valid = false;
        this.errorUpload = true;
        return;
      }
      else{
        let file = this.files[0]
        let FileExt = file.name.split('.')[1]
        if(FileExt =='xlsx') {
          const reader = new FileReader();
          const that = this
          reader.onload = function (e) {
            const data = e.target.result;
            const workbook = XLSX.read(data, {
              type: 'binary'
            });
            workbook.SheetNames.forEach(function (sheetName) {
              // Here is your object
              const XL_row_object = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);
              const json_object = JSON.stringify(XL_row_object);
              XL_row_object.forEach((node) => node.rate = that.SanitizeAmountToGrade(node.Grade));
              XL_row_object.forEach((node) => node.general_fund = that.SanitizeAmountToGrade(node.Grade) * parseInt(node.WeeksWorked));
              XL_row_object.forEach((node) => node.emp_firstname = node.Fullname);
              XL_row_object.forEach((node) => node.weeksCount =  node.WeeksWorked);
              XL_row_object.forEach((node) => node.class_grade = node.Grade);
              XL_row_object.forEach((node) => node.emp_idnumber = node.IDNumber);
              // XL_row_object.forEach((node) => node.endDate = that.sanitizeXslEDate(node.endDate));
              // let newData = that.RemoveDupicate(XL_row_object,'idNumber')
              that.returns = XL_row_object;
              return json_object;
            })

          };
          reader.onerror = function (ex) {
            console.log(ex);
          };
          reader.readAsBinaryString(file);
        }
        else{
          this.overlay = false;
          this.valid = false;
          this.errorUpload2 = true;
        }
      }

      this.overlay = false
    },
    SanitizeAmountToGrade(val){
      let amount = this.grades[0][val]
      return amount
    },
    async AddReturns() {
      let JWTToken = this.$store.getters.accessToken;
      console.log(this.$store.getters.accessToken);
      this.overlay = true;
      this.returns.forEach((node) => delete node.Fullname);
      this.returns.forEach((node) => delete node.Grade);
      this.returns.forEach((node) => delete node.IDNumber);
      this.returns.forEach((node) => node.currency = this.currency);
      this.returns.forEach((node) => node.period = this.period);
      this.returns.forEach((node) => node.batchnumber = this.GenerateBatchID(this.returns));
      this.returns.forEach((node) => node.organisation = this.$store.getters.OrgId);
      const config = {
        method: "post",
        url: this.base_url + "/returns/submit-returns/",
        data: this.returns,
        headers: {Authorization: `Bearer ${JWTToken}`}
      };
      axios(config)
          .then((response) => {
            if (response.status === 201) {
              console.log(response.data)
              this.overlay = false;
              this.successDialog = true;
            }
            else{
              console.log("in else")
              this.overlay = false;
              this.errorMessage = response.data.error
              this.errorDialog = true;
            }
          })
          .catch((error) => {
            console.log("in error")
            console.log(error,"info")
            this.overlay = false;
            this.errorDialog = true;
        });
      this.overlay = false;
    },
    GenerateBatchID(val){
      const TodayDate = moment().format("YYMMDDms");
      const BatchID = "NEC" + TodayDate + val.length
      return BatchID;
    },
    async getGrades(){
        const JWTToken = this.$store.getters.accessToken
        axios.get(this.base_url + '/returns/get-grades/' + this.period + '/' , {
              headers: {
                Authorization: `Bearer ${JWTToken}`
              }
            })
            .then(res => {
              if (res.status === 200) {
                this.grades = res.data
                this.PreviewFile()
              } else if (res.status === 401) {
                next("/login")
              }
              else {
                console.log('error')
              }
            })
    },
    async getPeriods(){
      const JWTToken = this.$store.getters.accessToken
      axios.get(this.base_url + '/returns/get-periods/' , {
        headers: {
          Authorization: `Bearer ${JWTToken}`
        }
      })
          .then(res => {
            if (res.status === 200) {
              this.periods = res.data
              console.log(this.periods)
            } else if (res.status === 401) {
              next("/login")
            }
            else {
              console.log('error')
            }
          })
    },
    GenerateMonth(year, month){
      if (month === "01"){
        return "January " + year
      }
      else if (month === "02"){
        return "February " + year
      }
      else if (month === "03"){
        return "March " + year
      }
      else if (month === "04"){
        return "April " + year
      }
      else if (month === "05"){
        return "May " + year
      }
      else if (month === "06"){
        return "June " + year
      }
      else if (month === "07"){
        return "July " + year
      }
      else if (month === "08"){
        return "August " + year
      }
      else if (month === "09"){
        return "September " + year
      }
      else if (month === "10"){
        return "October " + year
      }
      else if (month === "11"){
        return "November " + year
      }
      else if (month === "12"){
        return "December " + year
      }
    },
    async DownloadSample() {
      this.overlay = true
      await this.DownloadFN()
      this.overlay = false
    },
    async DownloadFN(){
      window.location.href = this.base_url + "/media/nec_template.xlsx";
    },



  },
};
</script>
